import React, { PureComponent } from 'react'

import {
  Paper,
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  ExpansionPanelDetails,
  Divider,
  TextField,
  InputAdornment,
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'

import { Autocomplete } from 'components'

export class RouteInfoBase extends PureComponent {
  componentDidMount() {
    const { getCarriers, getBuses, getDrivers } = this.props

    getCarriers()
    getBuses()
    getDrivers()
  }

  onRouteInfoChange = key => (e, prop) => {
    const { changeRouteInfo } = this.props

    const value = prop ? prop.newValue : e.target.value

    changeRouteInfo({ key, value })
  }

  onRouteInfoBlur = e => {
    const { setRouteInfo } = this.props

    const key = e.target.name
    const value = e.target.value

    setRouteInfo({ key, value })
  }

  removeSurname = fullname => {
    const splited = fullname.split(' ')

    return `${splited[1] || ''} ${splited[2] || ''}`
  }

  render() {
    const { carriagePhones, classes, carrierLabel, busQty, drivers, isPartner, routeId, isLimitedDispatcher,
      firstDriver, secondDriver, infoForDrivers, busNumber, buses, isDisabled, infoForPartners } = this.props

    const isDisabledDriver = isPartner
      && secondDriver
      && isLimitedDispatcher

    const driver1 = isDisabledDriver
      ? this.removeSurname(firstDriver)
      : firstDriver

    const driver2 = isDisabledDriver
      ? this.removeSurname(secondDriver)
      : secondDriver

    const disabled = isPartner
      || isLimitedDispatcher
      || !routeId

    return (
      <Paper className={isDisabled ? classes.disabled : null}>
        <ExpansionPanel defaultExpanded>

          <ExpansionPanelSummary expandIcon={<ExpandMore />}>
            <Typography>Інформація про рейс</Typography>
          </ExpansionPanelSummary>

          <Divider />

          <ExpansionPanelDetails className={classes.content}>
            <Typography variant='caption' gutterBottom align='center'>
              {carriagePhones.join(' | ')}
            </Typography>
            {!isPartner && !isLimitedDispatcher && (
              <TextField
                fullWidth
                name='infoForDrivers'
                label='Інформація для водіїв'
                value={infoForDrivers}
                onBlur={this.onRouteInfoBlur}
                margin='normal'
                disabled={!routeId}
                onChange={this.onRouteInfoChange('infoForDrivers')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {carrierLabel}
                    </InputAdornment>
                  ),
                }}
              />
            )}
            <TextField
              fullWidth
              name='infoForPartners'
              label='Інформація для партнерів'
              value={infoForPartners}
              onBlur={this.onRouteInfoBlur}
              margin='normal'
              disabled={disabled}
              onChange={this.onRouteInfoChange('infoForPartners')}
            />
            <Autocomplete
              name='driver_1'
              label='Водій №1'
              value={driver1}
              onBlur={this.onRouteInfoBlur}
              onChange={this.onRouteInfoChange('driver_1')}
              disabled={disabled}
              suggestion={drivers}
            />
            <Autocomplete
              name='driver_2'
              label='Водій №2'
              value={driver2}
              onBlur={this.onRouteInfoBlur}
              onChange={this.onRouteInfoChange('driver_2')}
              disabled={disabled}
              suggestion={drivers}
            />
            <Autocomplete
              name='busNumber'
              label='Транспортний засіб'
              value={busNumber}
              onBlur={this.onRouteInfoBlur}
              onChange={this.onRouteInfoChange('busNumber')}
              disabled={disabled}
              suggestion={buses}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    {busQty}
                  </InputAdornment>
                ),
              }}
            />
          </ExpansionPanelDetails>

        </ExpansionPanel>

      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RouteInfo/RouteInfo.js